import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Stars } from "@/components/reviews/Stars";
import { api } from "@/lib/api";
import { formatApiError, formatDate } from "@/lib/format";

const ReviewRow = ({ review }) => {
  const qc = useQueryClient();
  const toggle = async () => {
    try {
      await api.patch(`/admin/reviews/${review.id}`, { hidden: !review.hidden });
      toast.success(review.hidden ? "Recensione di nuovo visibile" : "Recensione nascosta");
      await Promise.all([["admin-reviews"], ["reviews", review.product_slug], ["products"]].map((k) => qc.invalidateQueries({ queryKey: k })));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };
  return (
    <li className={`flex flex-col gap-4 px-5 py-5 lg:flex-row lg:items-start lg:justify-between lg:px-6 ${review.hidden ? "opacity-60" : ""}`} data-testid={`admin-review-${review.id}`}>
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
          <Stars value={review.rating} />
          <p className="font-medium text-navy">{review.product_name}</p>
          <p className="text-[13px] text-slate2">{review.author} · ordine {review.order_ref} · {formatDate(review.created_at)}</p>
        </div>
        <p className="mt-2 text-[15px] text-ink">{review.comment || <span className="italic text-slate2">Solo voto, nessun commento</span>}</p>
      </div>
      <button type="button" onClick={toggle} data-testid={`admin-review-toggle-${review.id}`} className="h-11 shrink-0 rounded-full border border-navy/20 px-5 text-[15px] text-navy transition-colors hover:bg-navy hover:text-ivory">
        {review.hidden ? "Mostra di nuovo" : "Nascondi"}
      </button>
    </li>
  );
};

export const ReviewsTable = () => {
  const query = useQuery({ queryKey: ["admin-reviews"], queryFn: async () => (await api.get("/admin/reviews")).data });
  const reviews = Array.isArray(query.data) ? query.data : [];
  if (query.isLoading) return <p className="text-slate2">Caricamento recensioni…</p>;
  return (
    <div className="rounded-3xl border border-copper/20 bg-cream" data-testid="admin-reviews">
      <p className="border-b border-copper/20 px-6 py-4 text-[14px] leading-relaxed text-slate2">
        Le recensioni sono pubblicate subito. Nascondi solo quelle offensive o fuori tema, mai in base al voto: la legge vieta di filtrare le recensioni negative.
      </p>
      {reviews.length === 0 ? (
        <p className="p-10 text-center text-lg text-slate2" data-testid="admin-reviews-empty">Ancora nessuna recensione. Arriveranno dai clienti dopo la consegna.</p>
      ) : (
        <ul className="divide-y divide-copper/10">{reviews.map((r) => <ReviewRow key={r.id} review={r} />)}</ul>
      )}
    </div>
  );
};
